import { createContext } from 'react';
export const PayloadParserContext = createContext({
    entity: undefined,
    entityType: undefined,
    deviceType: undefined,
    readings: undefined,
});
